import * as React from 'react';
import { Button } from '@material-ui/core';
import { useIntl } from 'react-intl';
import Input from 'components/Input';
import { CreateLabel } from 'redux/ducks/data/labels';
import { onSubmitForm } from 'utils/helpers';

interface CreateNewLabelFormProps {
  onCreate: (label: CreateLabel) => void;
  closeModal: () => void;
}
const CreateNewLabelForm: React.FC<CreateNewLabelFormProps> = ({ onCreate, closeModal }) => {
  const intl = useIntl();
  const [name, setName] = React.useState('');

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>, value: string) => {
    setName(value);
  };

  return (
    <div style={{ minWidth: '300px' }}>
      <form onSubmit={onSubmitForm(() => onCreate({ name: name.trim() }))}>
        <Input
          type='text'
          required
          value={name}
          focusOnMount={true}
          name='label_name'
          label={intl.formatMessage({ id: 'name' })}
          onChange={handleNameChange}
          shouldValidate={(value: string) => value && value.trim().length > 0}
          fullWidth
          style={{ marginBottom: '24px' }}
        />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
          <Button onClick={closeModal}>{intl.formatMessage({ id: 'base.cancel' })}</Button>
          <Button
            variant='contained'
            color='primary'
            type='submit'
            disabled={!name || name.trim().length === 0}
          >
            {intl.formatMessage({ id: 'base.save' })}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default CreateNewLabelForm;
